export default "__VITE_ASSET__11deaa71__"